export interface RequestECatalogResponse {
    nextPage: string;
    filterHTML: string;
    items: RequestECatalogItem[] | null;
}

export interface RequestECatalogItem {
    name: string;
    number: string;
    eCatalogAvailable?: boolean;
    location: string;
    isFav: boolean;
    toggleFavUrl: string;
}
